import React from "react";
import { Outlet } from "react-router-dom";

function Dashlayout() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Dashlayout;
